export function load() {
    document.addEventListener('DOMContentLoaded', () => {
      const load = document.querySelector('.l-load');
      const loadCopy = document.querySelector('.l-load_copy');
      const mv = document.querySelector('.p-mv');

      if (!load) {
        mv?.classList.add('active');
        return;
      }

      // 0.1秒後：コピーをフェードイン
      window.setTimeout(() => {
        loadCopy?.classList.add('is-show');

        // コピー表示開始から0.2秒後：ローディング全体をフェードアウト
        window.setTimeout(() => {
          load.classList.add('is-hidden');
        }, 1600);
      }, 200);

      // .l-loadのフェードアウト完了後
      load.addEventListener(
        'transitionend',
        (event) => {
          if (
            event.target !== load ||
            event.propertyName !== 'opacity' ||
            !load.classList.contains('is-hidden')
          ) {
            return;
          }

          load.style.display = 'none';
          mv?.classList.add('active');
        },
        { once: true }
      );
    });
}